import Utils from "../../../../../shared/utils";

export const IMAGE_URL = Utils.buildProductPageImageLink('rent/safecheck/scale-animation.svg')
